import * as e from "react";
import a from "../lib/SSRBase.es.js";
import s from "../defs/DotsThreeVertical.es.js";
const r = e.forwardRef((t, o) => /* @__PURE__ */ e.createElement(a, { ref: o, ...t, weights: s }));
r.displayName = "DotsThreeVerticalIcon";
const m = r;
export {
  m as DotsThreeVertical,
  r as DotsThreeVerticalIcon
};
